export enum ColumnSettingsActionName {
  HIDE_COLUMNS,
  SELECT_GROUPING_COLUMN,
  RESET_SETTINGS,
  DISABLE_SUMMARY,
  ENABLE_AND_SELECT_SUMMARY_TYPE,
  SHOW_ADDITIONAL_CALCULATIONS,
  SET_OF_COLUMNS_SELECTED,
  FREEZE_COLUMNS
}

export interface ColumnSettingsDialogData {
  actions: Map<ColumnSettingsActionName, any>;
};
